import React, { useState, useEffect } from "react";
import { Container } from "react-bootstrap";
import MobileDetect from "mobile-detect";

import "./LiveStreamEmbed.css";

const LiveStreamEmbed = ({ stream }) => {
    const [isLandscape, setIsLandscape] = useState(false);

    const isMobileDevice = () => {
        const md = new MobileDetect(navigator.userAgent);
        if (md.mobile()) {
            return true;
        } else {
            return false;
        }
    };

    useEffect(() => {
        if (isMobileDevice() === true) {
            const handleOrientationChange = (e) => {
                setIsLandscape(e.matches);
            };

            const mql = window.matchMedia("(orientation: landscape)");
            mql.addEventListener("change", handleOrientationChange);
            setIsLandscape(mql.matches);

            return () => {
                mql.removeEventListener("change", handleOrientationChange);
            };
        }
    }, []);

    const streamMetadata = stream && stream.metadata

    const exitFullscreen = () => {
        setIsLandscape(false);
    };

    return (
        <Container className="py-0 py-md-5 my-0 my-md-5">
            <div
                style={{
                    marginTop: "25px",
                    marginBottom: "25px",
                    position: "relative",
                    width: "100%",
                    height: 0,
                    paddingBottom: "56.25%",
                    overflowY: "hidden",
                    boxShadow:
                        "rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px",
                }}
            >
                <iframe
                    title={`Live Stream Player for ${streamMetadata?.stream_short_name}`}
                    src={`/amscameras/${stream?.slug}.html`}
                    style={{
                        border: 0,
                        position: "absolute",
                        top: 0,
                        left: 0,
                        height: "100%",
                        width: "100%",
                        borderRadius: "6px",
                        overflowY: "hidden",
                    }}
                    loading="lazy"
                    className={`overflow-y-hidden ${
                        isLandscape ? "fullscreen" : ""
                    }`}
                    role="application"
                    tabIndex={0}
                    aria-label={`Live Stream Player for ${streamMetadata?.stream_short_name}`}
                    ariaDescription="This is the player container. Everything inside is related to the live stream player. Navigate into this to play the content."
                    allowFullScreen={true}
                />
                {isLandscape && (
                    <div id="player-exit-btn-container">
                        <button
                            type="button"
                            className="btn btn-transparent"
                            onClick={exitFullscreen}
                        >
                            ====
                        </button>
                    </div>
                )}
            </div>
        </Container>
    );
};

export default LiveStreamEmbed;
